var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property, css, state } from 'lit-element';
export class InfoPointTemplateFullscreenWrap {
    async createView() {
        return document.createElement('infopoint-templatefullscreen');
    }
}
let InfoPointTemplateFullscreen = class InfoPointTemplateFullscreen extends LitElement {
    constructor() {
        super(...arguments);
        this.path = '/';
        this.switchIcon = "/assets/default-icon.png";
        this.currentViewName = "default";
        this.views = {};
    }
    setContent(elem) {
        elem.slot = 'content-slot';
        // Musi se pouzivat this, protoze kdyby se pouzilo this.shadowRoot, tak se to vloží pod shadowRoot,
        // ale pro správné fungování slotů je potřeba aby to bylo na stejné úrovni jako je shadowRoot
        this.appendChild(elem);
    }
    async switchLayout() {
        const viewNames = Object.keys(this.views);
        let idx = viewNames.findIndex((v) => v === this.currentViewName);
        idx += 1;
        if (idx === viewNames.length) {
            idx = 0;
        }
        this.currentViewName = viewNames[idx];
        this.switchIcon = `/assets/${this.currentViewName}-icon.png`;
        this.dispatchEvent(new CustomEvent("viewchanged", {
            detail: {
                viewName: this.currentViewName
            }
        }));
    }
    render() {
        return html `
    <div class="slot">
      <slot name='content-slot'></slot>
    </div>

    ${Object.keys(this.views).length > 1 ?
            html `
        <div class="toggleView" @click="${(e) => this.switchLayout()}" style="position: absolute; right: 0; bottom: 9%; padding: 2rem;">
          <div>
            <img src="${this.switchIcon}">
          </div>
        </div>` : ``}
    `;
    }
};
InfoPointTemplateFullscreen.styles = css `
    :host {
      box-sizing: border-box;
      display: flex;
      width: 100%;
      height: 100%;
      background-color: #E2F3F3;
    }

    .slot {
      box-sizing: border-box;
      width: 100%;
      position: relative;
    }

    slot {
      position: absolute;
    }
  `;
__decorate([
    property()
], InfoPointTemplateFullscreen.prototype, "navigator", void 0);
__decorate([
    property()
], InfoPointTemplateFullscreen.prototype, "application", void 0);
__decorate([
    property()
], InfoPointTemplateFullscreen.prototype, "homeUrl", void 0);
__decorate([
    property()
], InfoPointTemplateFullscreen.prototype, "path", void 0);
__decorate([
    state()
], InfoPointTemplateFullscreen.prototype, "switchIcon", void 0);
__decorate([
    state()
], InfoPointTemplateFullscreen.prototype, "currentViewName", void 0);
__decorate([
    state()
], InfoPointTemplateFullscreen.prototype, "views", void 0);
InfoPointTemplateFullscreen = __decorate([
    customElement('infopoint-templatefullscreen')
], InfoPointTemplateFullscreen);
export { InfoPointTemplateFullscreen };
//# sourceMappingURL=infopoint-templatefullscreen.js.map